import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import ContactFinder from './ContactFinder';

const ContactFinderLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    competitorResearch: false,
    messages: false,
    support: false,
    settings: false
  });
  const [notifications, setNotifications] = useState([
    { id: 1, type: 'success', title: 'New affiliate approved', message: 'John Doe has been approved for your campaign', time: '2 min ago', unread: true },
    { id: 2, type: 'warning', title: 'Campaign budget alert', message: 'Campaign "Summer Sale" is 90% spent', time: '1 hour ago', unread: true },
    { id: 3, type: 'info', title: 'Weekly report ready', message: 'Your performance report is ready to view', time: '3 hours ago', unread: false },
    { id: 4, type: 'success', title: 'Payment received', message: 'Commission payment of $2,450 processed', time: '5 hours ago', unread: false }
  ]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [brands, setBrands] = useState([
    {
      id: 1,
      name: 'Zodiac Casino',
      url: 'https://zodiac.casino/',
      favicon: '/api/placeholder/24/24',
      vertical: 'Casino,Sports',
      healthScore: 1,
      estimatedTraffic: 809,
      liveAffiliates: 639,
      affiliateChange: 52,
      untappedOpportunities: 2844,
      opportunityChange: 156,
      country: 'CA'
    }
  ]);
  const [recentlyContactedAffiliates] = useState([
    {
      id: 1,
      name: 'Sarah Johnson',
      email: 'sarah.j@affiliatemax.com',
      brand: 'Zodiac Casino',
      lastContact: '2 hours ago',
      status: 'responded',
      avatar: 'SJ',
      country: 'US',
      revenue: '$2,450'
    },
    {
      id: 2,
      name: 'Michael Chen',
      email: 'mchen@gamingpartners.net',
      brand: 'Sports Bet Pro',
      lastContact: '5 hours ago',
      status: 'pending',
      avatar: 'MC',
      country: 'CA',
      revenue: '$1,890'
    },
    {
      id: 3,
      name: 'Emma Rodriguez',
      email: 'emma@casinoaffs.com',
      brand: 'Lucky Slots',
      lastContact: '1 day ago',
      status: 'responded',
      avatar: 'ER',
      country: 'MX',
      revenue: '$3,120'
    }
  ]);

  const [newAffiliatesByCountry] = useState([
    { country: 'United States', code: 'US', count: 24, change: '+12%' },
    { country: 'Canada', code: 'CA', count: 18, change: '+8%' },
    { country: 'United Kingdom', code: 'GB', count: 15, change: '+15%' },
    { country: 'Australia', code: 'AU', count: 12, change: '+6%' },
    { country: 'Germany', code: 'DE', count: 9, change: '+3%' }
  ]);

  const [currentUser] = useState({
    name: 'Vishnu',
    email: 'vishnu@company.com',
    plan: 'Enterprise User',
    avatar: 'VV',
    initials: 'VV'
  });

  const [dashboardStats] = useState({
    totalProjects: 5,
    totalAffiliatesContacted: 247,
    totalAffiliates: 1842,
    newAffiliatesAdded: 23
  });

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  return (
    <div className="min-h-screen transition-all duration-300 bg-gray-50 dark:bg-slate-950 text-sm">
      {/* Sidebar Component */}
      <Sidebar 
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        openMenus={openMenus}
        toggleMenu={toggleMenu}
      />

      {/* Main Content Area */}
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        {/* Header Component */}
        <Header 
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          notifications={notifications}
          setNotifications={setNotifications}
          showNotifications={showNotifications}
          setShowNotifications={setShowNotifications}
          showProfileDropdown={showProfileDropdown}
          setShowProfileDropdown={setShowProfileDropdown}
          currentUser={currentUser}
        />

        {/* Main Content Component */}
        <ContactFinder 
          currentUser={currentUser}
          dashboardStats={dashboardStats}
          brands={brands}
          recentlyContactedAffiliates={recentlyContactedAffiliates}
          newAffiliatesByCountry={newAffiliatesByCountry}
        />
      </div>
    </div>
  );
};

export default ContactFinderLayout;